import { Steps } from 'antd';
import { LoadingOutlined, ClockCircleOutlined  } from '@ant-design/icons';

const StepProgressBar = ({ stepsInfo, currentStepIndex, percent,desc }) => {

  // بناء الخطوات مع حالة كل خطوة
  const steps = stepsInfo.map((step, index) => {
    let status = "wait";
    if (index < currentStepIndex) status = "finish";
    else if (index === currentStepIndex) status = "process";

    return {
      title: step.title,
      description: step.description,
      icon: (index === currentStepIndex) ? <LoadingOutlined /> : null,
      status,
    };
  });

  return (

    <>
      <div className='flex gap-2 custom-ant'>
        <ClockCircleOutlined  />
        <p className='text-20 text-gray text-bold text-inline-block my-20' >{desc}</p>
      </div>


      <Steps
        // status="error"
        current={currentStepIndex}
        // percent={percent}
        items={steps} />
    </>


  )
};

export default StepProgressBar;
